module.exports = __webpack_public_path__ + "static/media/N2.3f63c416.jpg";